module.exports = __webpack_public_path__ + "assets/47de1b33ce3dc0e33856a12efed7b22f.png";